export function calculateTotal(cart) {
  let total = 0;
  cart.cartitem_set.forEach(item => {
    total += Number(item.spare_part.price) * Number(item.quantity);
  });
  return total;
}
